import { PartnerBank } from "@ctypes";
import { useFeatureFlags } from "@hooks/application/useFeatureFlags";
import { useUser } from "@hooks/user";
import { findEnabledPartnerBank } from "@utils/partner";

export const usePartnerBank = (): { partnerBank: PartnerBank | null } => {
  const { user } = useUser();
  const { partnerBankFlags } = useFeatureFlags();

  return { partnerBank: findEnabledPartnerBank(user?.partnerId, partnerBankFlags) };
};
